import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
const NotFound = lazy(() => import("../pages/NotFound"));
const Home = lazy(() => import("../pages/home/page"));
const Apply = lazy(() => import("../pages/apply/page"));
const GalleryPage = lazy(() => import("../pages/gallery/page"));
const StandardStretchTents = lazy(() => import("../pages/products/standard-stretch-tents/page"));
const CustomStretchTents = lazy(() => import("../pages/products/custom-stretch-tents/page"));
const CustomPrintedSkins = lazy(() => import("../pages/products/custom-printed-skins/page"));
const BespokeDecor = lazy(() => import("../pages/products/bespoke-decor/page"));
const ProductsPage = lazy(() => import("../pages/products/page"));
const BlogPage = lazy(() => import("../pages/blog/page"));
const ContactPage = lazy(() => import("../pages/contact/page"));
const FabricAndColoursPage = lazy(() => import("../pages/products/fabric-and-colours/page"));
// Rigging Equipment page intentionally unrouted (hidden, not deleted) - code
// still lives at ../pages/products/rigging-equipment/page, undecided if it
// comes back or gets removed for good.
const EngineeringSafetyPage = lazy(() => import("../pages/engineering-safety/page"));
const AboutPage = lazy(() => import("../pages/about/page"));
const StretchTentSizesPage = lazy(() => import("../pages/blog/stretch-tent-sizes/page"));
const StretchTentRentalGuidePage = lazy(() => import("../pages/blog/stretch-tent-rental-guide/page"));
const LightningInABottlePage = lazy(() => import("../pages/blog/lightning-in-a-bottle/page"));
const EnhanceFestivalAppealPage = lazy(() => import("../pages/blog/enhance-festival-appeal/page"));
const LuxuryBedouinTentsPage = lazy(() => import("../pages/blog/luxury-bedouin-tents/page"));
const BehindScenePopProTentsPage = lazy(() => import("../pages/blog/behind-scenes-pop-pro-tents/page"));
const FestivalStretchTentPage = lazy(() => import("../pages/blog/festival-stretch-tent/page"));
const TenReasonsStretchTentPage = lazy(() => import("../pages/blog/10-reasons-stretch-tent/page"));
const StretchTentFabricsPage = lazy(() => import("../pages/blog/stretch-tent-fabrics/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/apply",
    element: <Apply />,
  },
  {
    path: "/gallery",
    element: <GalleryPage />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/products/standard-stretch-tents",
    element: <StandardStretchTents />,
  },
  {
    path: "/products/custom-stretch-tents",
    element: <CustomStretchTents />,
  },
  {
    path: "/products/custom-printed-skins",
    element: <CustomPrintedSkins />,
  },
  {
    path: "/products/bespoke-decor",
    element: <BespokeDecor />,
  },
  {
    path: "/products/fabric-and-colours",
    element: <FabricAndColoursPage />,
  },
  {
    path: "/engineering-safety",
    element: <EngineeringSafetyPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/suitable-stretch-tent-sizes-for-your-outdoor-event",
    element: <StretchTentSizesPage />,
  },
  {
    path: "/blog/stretch-tent-rentals-guide-tips-considerations",
    element: <StretchTentRentalGuidePage />,
  },
  {
    path: "/blog/lightning-in-a-bottle-festival",
    element: <LightningInABottlePage />,
  },
  {
    path: "/blog/enhance-festival-appeal-stretch-tents",
    element: <EnhanceFestivalAppealPage />,
  },
  {
    path: "/blog/luxury-bedouin-tents-exclusive-events",
    element: <LuxuryBedouinTentsPage />,
  },
  {
    path: "/blog/behind-the-scenes-pop-pro-tents",
    element: <BehindScenePopProTentsPage />,
  },
  {
    path: "/blog/festival-stretch-tent-outdoor-music-festival",
    element: <FestivalStretchTentPage />,
  },
  {
    path: "/blog/10-reasons-choose-stretch-tent-next-event",
    element: <TenReasonsStretchTentPage />,
  },
  {
    path: "/blog/our-stretch-tent-fabrics-outperform-other-fabrics",
    element: <StretchTentFabricsPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },

  // Legacy Readdy/WordPress URL redirects live in public/_redirects as real
  // server-side 301s, and deliberately NOT here as well.
  //
  // A router <Navigate> rule is client-side, so it never runs for the traffic
  // that matters: an old URL is always a fresh page load, which Cloudflare
  // answers before React exists. A copy here is dead code that only drifts out
  // of sync with the file that actually serves the redirect - which is exactly
  // how ~30 old URLs ended up returning 404 to Google (fixed 2026-07-20).
  //
  // Add new redirects to public/_redirects.

  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;